import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative py-20 md:py-28 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=A%20warm%20artistic%20illustration%20of%20a%20dreamy%20library%20with%20floating%20books%20and%20comic%20pages%2C%20soft%20amber%20and%20cream%20light%20streaming%20through%20windows%2C%20magical%20atmosphere%2C%20Korean%20manhwa%20aesthetic%2C%20warm%20golden%20tones%2C%20ethereal%20and%20inviting&width=1920&height=800&seq=cta-bg-home-02&orientation=landscape"
        alt="开启韩漫之旅"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/55"></div>

      <div className="relative z-10 w-full px-4 md:px-6 lg:px-10 text-center">
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-background-50 tracking-wide">
          开启韩漫之旅
        </h2>
        <p className="mt-4 text-base md:text-lg text-background-200/80 max-w-xl mx-auto leading-relaxed">
          海量免费韩国漫画等你来探索，下拉式阅读，随时随地畅享韩漫世界
        </p>
        <Link
          to="/category/all"
          className="mt-8 inline-flex items-center gap-3 px-8 py-4 bg-foreground-950 text-background-50 rounded-full text-base font-semibold hover:bg-foreground-900 transition-all duration-300 whitespace-nowrap cursor-pointer group"
        >
          <span className="w-7 h-7 rounded-full bg-accent-500 flex items-center justify-center flex-shrink-0">
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-book-open-line text-background-50 text-sm"></i>
            </span>
          </span>
          免费观看
          <span className="w-4 h-4 flex items-center justify-center group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform">
            <i className="ri-arrow-right-up-line"></i>
          </span>
        </Link>
      </div>
    </section>
  );
}